import { Pipe, PipeTransform } from '@angular/core';
import { ServiceCaseStatus } from '../enum/service-case-status.enum';

@Pipe({
  name: 'ServiceCaseStatus',
  standalone: true,
})
export class ServiceCaseStatusPipe implements PipeTransform {
  /**
   * Transforms the ServiceCaseStatus enum value into a user-friendly string.
   * @param value - The ServiceCaseStatus enum value to transform.
   * @returns A string representation of the ServiceCaseStatus.
   */
  transform(value: ServiceCaseStatus | null) {

    if (value == ServiceCaseStatus.New) {
      return 'serviceCase.status.new';
    } else if (value == ServiceCaseStatus.Open) {
      return 'serviceCase.status.open';
    }else if (value == ServiceCaseStatus.InProgress) {
      return 'serviceCase.status.inProgress';
    }
    else if (value == ServiceCaseStatus.Closed) {
      return 'serviceCase.status.closed';
    } else if (value == ServiceCaseStatus.Resolved) {
      return 'serviceCase.status.resolved';
    } else if(value == ServiceCaseStatus.AwaitingInfo) {
      return 'serviceCase.status.awaitingInfo';
    } else {
      return ''; // Return 'default' for unrecognized statuses
    }
  }
}
